export function styleIfDifferent<T>(current: T | null | undefined, previous: T | null | undefined, showDiff: boolean) {
  return !showDiff || areNilOrSame(current, previous) ? undefined : cellWithDiffStyle;
}

function areNilOrSame<T>(val1: T | null | undefined, val2: T | null | undefined) {
  return (!val1 && !val2) || val1 === val2;
}

const cellWithDiffStyle = {
  background: "rgba(241,211,38,0.63)",
};
